// Expose global declarations on `window`
// https://github.com/Microsoft/TypeScript/issues/19816
declare global {
  interface Window {
    PopStateEvent: any;
  }
}

/**
 * Returns a wrapper around the HTML5 history API.
 * @param { prefix } Router prefix
 */
const getHistory = ({ prefix = "" }) => ({
  push(path: string) {
    window.history.pushState(null, "", prefix + path);
    window.dispatchEvent(new window.PopStateEvent("popstate"));
  },
  replace(path: string) {
    window.history.replaceState(null, "", prefix + path);
    window.dispatchEvent(new window.PopStateEvent("popstate"));
  },
  listen(cb: any) {
    return window.addEventListener("popstate", cb);
  }
});

export default getHistory;
